
import {
  getGoodsFileCategory,
  getGoodsFileList,
  getStoreGoodsNameList,
  updateGoodsFilePrice,
} from "@/api/ccxIntegratedService";
import PinyinMatch from "pinyin-match";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import GoodsItem from "./components/GoodsItem.vue";
import { pxToVw } from "@/utils/pxToVw";

@Component({
  name: "GoodsManage",
  components: { GoodsItem },
})
export default class GoodsManage extends Vue {
  @Getter companyId!: string;
  @Getter bottomSafetyHeight!: number;

  get bottomSafetyHeightVw(): string {
    return this.bottomSafetyHeight ? pxToVw(this.bottomSafetyHeight) : pxToVw(12);
  }

  get searchDisplayValue(): string {
    if (this.isScan && this.params.queryContent) {
      return '扫码结果：' + this.params.queryContent
    }
    return this.params.queryContent
  }

  set searchDisplayValue(val: string) {
    this.params.queryContent = val
  }


  goodsList = [];
  loading = false;
  finished = false;
  refreshing = false;
  isBatch = false;
  searchFocused = false;
  params = {
    pageIndex: 1,
    pageSize: 10,
    queryContent: "",
    categoryId: "",
    categoryType: "",
    categoryName: "全部分类",
    barcode: '' , // 条形码
  };
  showClassify = false;
  treeData: any = [
    {
      categoryName: "全部分类",
      categoryId: "",
      children: [
        {
          categoryName: "全部",
          categoryId: "",
          children: [
            {
              categoryName: "全部",
              categoryId: "",
            },
          ],
        },
      ],
    },
    {
      categoryName: "门店商品",
      categoryId: "",
      children: [
        {
          categoryId: "",
          categoryName: "全部",
          categoryType: 1,
          children: [
            {
              categoryId: "",
              categoryName: "全部",
              categoryType: 1,
              children: [],
            },
          ],
        },
      ],
      categoryType: 1,
    },
    {
      categoryName: "微店商品",
      categoryId: "",
      children: [
        {
          categoryId: "",
          categoryName: "全部",
          categoryType: 2,
          children: [
            {
              categoryId: "",
              categoryName: "全部",
              categoryType: 2,
              children: [],
            },
          ],
        },
      ],
      categoryType: 2,
    },
  ];
  checkedList = [0, 0, 0];
  listScrollTop = 0
  barcode = ''
  isScan = false
  clearingScan = false
  storeGoodsNameList: string[] = []
  storeGoodsNameTask: Promise<void> | null = null
  matchedQueryContent: string | null = null
  memoryCode = ""

  created() {
    this.getGoodsFileListFn();
    this.getGoodsFileCategoryFn();
    this.storeGoodsNameTask = this.getStoreGoodsNameListFn();
  }
  onLoad() {
    this.params.pageIndex++;
    this.getGoodsFileListFn();
  }

  toScan () {
    this.params.queryContent = ''
    this.$bridge.callHandler('toQRCodePage', {}, async(res: string) => {
      this.barcode = res
      this.params.barcode = this.barcode
      this.params.pageIndex = 1
      const { data } = await getGoodsFileList({
        storeId: this.companyId,
        ...this.params,
      })
      this.refreshing = false
      const records = data.records || []
      if (records.length && records[0].goodsName) {
        this.goodsList = records.map((item) => ({
          ...item,
          isEdit: this.isBatch,
          price: item.price || 0,
          offlinePrice: item.offlinePrice || 0,
          copyPrice: item.price || 0,
          copyOfflinePrice: item.offlinePrice || 0,
        }))
        this.finished = this.goodsList.length >= data.totalRecords
        this.params.queryContent = records[0].goodsName
        this.isScan = true
        this.$toast(`已找到：${records[0].goodsName}`)
      } else {
        this.$toast("该商品尚未收录")
      }

      // 下面是做了区分门店微店的处理逻辑
      // 要根据返回的69码 获取商品名称信息
      // 搜索到该商品，且为门店商品，则获取该商品的“商品名称”，该界面退出，在【商品管理】界面搜索栏内回填，并进行搜索，详见【识别到商品】页签；
      // 搜到该商品，但不是门店商品，则扫描流程结束，扫码界面退出，提示：该商品未添加为门店商品。
      // 查询无结果直接提示    有结果直接返回
      // if (records.length && records[0].goodsName) {
      //   if (records[0].isOfflineProduct === 1) {
      //     this.goodsList = records.map((item) => ({
      //       ...item,
      //       isEdit: this.isBatch,
      //       joinPrice: item.joinPrice || 0,
      //       offlinePrice: item.offlinePrice || 0,
      //       copyJoinPrice: item.joinPrice || 0,
      //       copyPrice: item.price || 0,
      //       copyOfflinePrice: item.offlinePrice || 0,
      //     }))
      //     this.finished = this.goodsList.length >= data.totalRecords
      //     this.params.queryContent = records[0].goodsName
      //     this.isScan = true
      //     this.$toast(`已找到：${records[0].goodsName}`)
      //   } else {
      //     this.$toast("该商品未添加为门店商品。")
      //   }
      // } else {
      //   this.$toast("该商品尚未收录")
      // }
    })
  }

  clearScan () {
    this.isScan = false
    this.barcode = ''
    this.params.queryContent = ''
    this.params.barcode = ''
    this.matchedQueryContent = null
    this.memoryCode = ""
    this.clearingScan = true
    setTimeout(() => { this.clearingScan = false }, 300)
    this.getGoodsFileListFn()
  }

  onRefresh() {
    this.params.pageIndex = 1;
    this.params.barcode = '';
    this.refreshing = true;
    this.getGoodsFileListFn();
  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  // 3. 缓存生命周期：页面激活（从详情页返回）时触发
  activated() {
    document.querySelector('.add-goods-scroll') && document.querySelector('.add-goods-scroll').scrollTo(0, this.listScrollTop)
  }

  async getGoodsFileListFn() {
    const { data } = await getGoodsFileList({
      storeId: this.companyId,
      ...this.params,
      queryContent: this.matchedQueryContent != null ? this.matchedQueryContent : this.params.queryContent,
      ...(this.memoryCode ? { memoryCode: this.memoryCode } : {}),
    });
    this.refreshing = false;
    const processedRecords = data.records.map((item) => ({
      ...item,
      isEdit: this.isBatch,
      price: item.price || 0,
      offlinePrice: item.offlinePrice || 0,
      copyPrice: item.price || 0,
      copyOfflinePrice: item.offlinePrice || 0,
    }));

    if (this.params.pageIndex === 1) {
      this.goodsList = processedRecords;
    } else {
      this.goodsList = this.goodsList.concat(processedRecords);
    }

    if (this.goodsList.length >= data.totalRecords) {
      this.finished = true;
    } else {
      this.finished = false;
    }
    this.loading = false;
  }

  // 批量按钮
  batchPriceAdjustment() {
    this.isBatch = true;
    this.goodsList.forEach((item, index) => {
      item.isEdit = true;
    });
  }

  // 单个编辑
  handleEdit(item: { isEdit: boolean; goodsId: string }) {
    const target = this.goodsList.find((i) => i.goodsId === item.goodsId);
    if (!target) return;
    if (item.isEdit) {
      this.submit();
    } else {
      item.isEdit = !item.isEdit;
    }
  }
  onCancel() {
    this.goodsList.forEach((item) => {
      item.isEdit = false;
      item.copyPrice = item.price || 0;
      item.copyOfflinePrice = item.offlinePrice || 0;
    });
    this.isBatch = false;
  }
  async submit() {
    const priceList = this.goodsList
      .filter(
        (i) => i.price !== i.copyPrice || i.offlinePrice !== i.copyOfflinePrice
      )
      .map((i) => ({
        ...i,
        price: i.copyPrice,
        offlinePrice: i.copyOfflinePrice,
        storeId: this.companyId,
      }));
    await updateGoodsFilePrice({
      priceList,
    });
    this.$toast.success("编辑成功");
    this.goodsList.forEach((item, index) => {
      item.price = item.copyPrice;
      item.offlinePrice = item.copyOfflinePrice;
      item.isEdit = false;
    });
    this.isBatch = false;
  }

  handleClickOne(index) {
    this.$set(this.checkedList, 0, index);
    this.checkedList[1] = 0;
    this.checkedList[2] = 0;
  }
  handleClickTwo(index) {
    console.log(index);

    this.$set(this.checkedList, 1, index);
    this.checkedList[2] = 0;
  }
  handleClickThree(index) {
    this.$set(this.checkedList, 2, index);
  }

  async getGoodsFileCategoryFn() {
    const { data } = await getGoodsFileCategory({
      storeId: this.companyId,
      isTree: 1,
    });

    data.map((item: any) => {
      if (item.categoryType === 1) {
        this.treeData[1].children.push(item);
      } else {
        this.treeData[2].children.push(item);
      }
    });

    console.log(this.treeData, "*********");
    this.treeData.forEach((item) => {
      item.children.forEach((it) => {
        if (!it.categoryId) return;
        it.children.unshift({
          categoryId: it.categoryId,
          categoryName: "全部",
          categoryType: it.categoryType,
        });
      });
    });
  }

  async getStoreGoodsNameListFn() {
    try {
      const { data } = await getStoreGoodsNameList({
        storeId: this.companyId,
      });
      this.storeGoodsNameList = this.normalizeStoreGoodsNames(data);
    } catch (error) {
      this.storeGoodsNameList = [];
    }
  }

  normalizeStoreGoodsNames(data: any): string[] {
    const source = Array.isArray(data)
      ? data
      : data?.records || data?.list || data?.goodsNameList || [];
    if (!Array.isArray(source)) return [];
    const names = source
      .map((item) => {
        return String(item?.goodsName).trim();
      })
      .filter(Boolean);
    return Array.from(new Set(names));
  }

  isPinyinKeyword(keyword: string) {
    const text = keyword.replace(/\s+/g, "");
    return /[a-zA-Z]/.test(text);
  }

  matchStoreGoodsKeyword(keyword: string) {
    const texts = new Set<string>();
    this.storeGoodsNameList.forEach((name) => {
      const range = PinyinMatch.match(name, keyword);
      if (!range) return;
      const text = name.slice(range[0], range[1] + 1);
      if (text) texts.add(text);
    });
    return Array.from(texts).join("，");
  }

  async handleSearch() {
    if (this.storeGoodsNameTask) {
      await this.storeGoodsNameTask;
    }
    const keyword = (this.params.queryContent || "").trim();
    if (this.isPinyinKeyword(keyword)) {
      const matched = this.matchStoreGoodsKeyword(keyword);
      this.matchedQueryContent = matched || keyword;
      this.memoryCode = matched ? this.params.queryContent : "";
    } else {
      this.matchedQueryContent = null;
      this.memoryCode = "";
    }
    this.onSearch();
  }

  onSearch() {
    this.params.pageIndex = 1;
    this.params.barcode = ''
    this.searchFocused = false
    // 主动让输入框失焦，收起移动端键盘，确保聚焦态与实际一致
    const activeEl = document.activeElement as HTMLElement | null
    activeEl && activeEl.blur()
    this.getGoodsFileListFn();
    this.showClassify = false;
  }
  openClassify() {
    this.showClassify = true;
  }
  onConfirm() {
    if (this.checkedList[2]) {
      const category =
        this.treeData[this.checkedList[0]].children[this.checkedList[1]]
          .children[this.checkedList[2]];
      this.params.categoryId = category.categoryId;
      this.params.categoryType = category.categoryType;
      this.params.categoryName = category.categoryName;
    } else if (this.checkedList[1]) {
      const category =
        this.treeData[this.checkedList[0]].children[this.checkedList[1]];
      this.params.categoryId = category.categoryId;
      this.params.categoryName = category.categoryName;
      this.params.categoryType = category.categoryType;
    } else {
      const category = this.treeData[this.checkedList[0]];
      this.params.categoryId = category.categoryId;
      this.params.categoryType = category.categoryType;
      this.params.categoryName = category.categoryName;
    }
    this.showClassify = false;
    this.handleSearch();
  }
  onCancelClassify() {
    this.checkedList = [0, 0, 0];
    this.showClassify = false;
    this.params.categoryId = "";
    this.params.categoryType = "";
    this.params.categoryName = "全部分类";
    this.handleSearch();
  }
}
